import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { DV360_APP_LP_SEND_TO, shouldLoadDv360Floodlight } from "@/lib/dv360Floodlight";
const NOSCRIPT_PIXEL_SRC = "https://ad.doubleclick.net/ddm/activity/src=16638578;type=invmedia;cat=black003;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=;gdpr_consent=;ord=1?";

/**
 * Fires App LP conversion on https://app.blacksmith.sh/ (root).
 * Pair with {@link Dv360FloodlightGlobal} in _app.
 */
export function Dv360FloodlightAppLpConversion() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  if (!shouldLoadDv360Floodlight()) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <noscript><img src={NOSCRIPT_PIXEL_SRC} width={1} height={1} alt="" /></noscript>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  if (!shouldLoadDv360Floodlight()) {
    return;
  }
  if (typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "conversion", {
    allow_custom_scripts: true,
    send_to: DV360_APP_LP_SEND_TO
  });
}